// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"89720fbd","70":"e2e07ee2","844":"31d6cfe0","997":"1df1a816"}[chunkId] + ".chunk.css";
};